import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useRoutes } from '../routes';
import UnsubscribeJobAlert from './jobalert';
import Unsubscribe from './unsubscribe';
import { Helmet } from 'react-helmet';
import translations from './.vocab';
import { useTranslations } from '@vocab/react';
import { PageTitles } from '../pageTitle';
import PageLoader from '../page-loader';
import { useTypedSelector } from 'src/reducers';
import { useUserProfile } from '../hooks/useUserProfile';
import { useSetCandidateId } from '../hooks/useSetCandidateId';
import { useSetTrackingContext } from '../tracking/tealium';

const UnsubscribeContainer = () => {
  const { authenticationStatus } = useUserProfile();

  useSetCandidateId();

  useSetTrackingContext();

  const [token, setToken] = useState('');
  const [product, setProduct] = useState('');

  const navigate = useNavigate();
  const { preferenceCentrePath } = useRoutes();
  const location = useLocation();
  const brand = useTypedSelector((store) => store.page.pageAnalytics.brand);
  const { t } = useTranslations(translations);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const paramToken = params.get('token');
    const paramProduct = params.get('product');
    if (paramProduct) {
      setProduct(paramProduct);
    }
    if (paramToken) {
      setToken(paramToken);
    } else {
      navigate(preferenceCentrePath);
    }
  }, [navigate, location.search, preferenceCentrePath]);

  const getUnsubscribeContent = () =>
    product?.toLocaleLowerCase() === 'jobalert' ? (
      <UnsubscribeJobAlert
        token={token}
        authenticationStatus={authenticationStatus}
      />
    ) : (
      <Unsubscribe token={token} brand={brand} />
    );

  return (
    <>
      <Helmet>
        <title>{`${PageTitles[brand]} - ${t('unsubscribe-page-title')}`}</title>
      </Helmet>
      {token ? getUnsubscribeContent() : <PageLoader />}
    </>
  );
};

export default UnsubscribeContainer;
